import { useCallback } from 'react'
import { useCreateDocumentPage } from '../document_pages'

export const useCreateOperationStep = (props: {
  documentVersionId?: string | null
  invalidateOnSuccess?: boolean
}) => {
  const { isPending, mutateAsync: createDocumentPage } = useCreateDocumentPage({
    invalidateOnSuccess: props?.invalidateOnSuccess,
  })

  const mutate = useCallback(
    ({
      documentVersionId,
      parentDocumentId,
      orderNumber,
    }: {
      documentVersionId: string
      parentDocumentId: string | null
      orderNumber: number
    }) => {
      return createDocumentPage({
        documentVersionId,
        orderNumber,
        values: {
          name: '',
          template_values: {},
          parent_id: parentDocumentId,
        },
      })
    },
    [createDocumentPage],
  )

  return {
    isPending,
    mutate,
  }
}
